import React, { useState, useEffect, useContext } from 'react';
import Breadcrumb from '../components/Breadcrumb';
import { BiSolidEditAlt } from 'react-icons/bi';
import { IoNewspaperOutline, IoSearchSharp } from 'react-icons/io5';
import { MdDeleteForever } from 'react-icons/md';
import { CiEdit } from 'react-icons/ci';
import { TiTick } from 'react-icons/ti';
import { Link, useSearchParams } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import Multiselect from 'multiselect-react-dropdown';
import Select from 'react-dropdown-select';
import { parseJSON, set } from 'date-fns-jalali';
import { MdAddBox, MdDelete } from 'react-icons/md';
import { Player } from '@lottiefiles/react-lottie-player';
import { GrFormNext, GrFormPrevious } from 'react-icons/gr';
import { FaRegWindowClose } from 'react-icons/fa';
import { DataContext } from '../context/DataProvider';
import SearchLawDropDown from '../SearchableDropDown/SearchLawDropDown';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import { format as jalaliFormat } from 'date-fns-jalali';
import { AiFillDislike, AiFillLike } from 'react-icons/ai';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import LawType from '../SearchableDropDown/LawType';
import SubjectCode from './SubjectCode';

export type FilterSearchType={
  Method: number,
  Type: number|null,
  search: string,
  fromDate: string |null,
  toDate: string |null,
  isReplated: boolean,
  subject: number,
}




const NewSubjectCode = () => {
  const [savePage, setSavePage] = useState(1);

  const [SearchResult, setSearchResult] = useState([]);
  // let [RowNum, setRowNum] = useState(0);
  const [value, setValue] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [searchParams, setsearchParams] = useSearchParams();
  const page: number | any = searchParams.get('page');
  const [pageCount, setpageCount] = useState(0);
  const [SearchPage, setSearchPage] = useState(null);
  const [pagesize, setPageSize] = useState(30);
  const [pageSearch, setpageSearch] = useState(0);
  // const [code, setcode] = useState([]);
  // const [selectID, setselectID] = useState([]);
  const [subjectCode, setSubjectCode] = useState({});
  const [SubjectList, setSubjectList] = useState([]);
  const [isLoading, setisLoading] = useState(true);
  const [isOpen, setOpen] = useState(false);
  const [isOpenDelete, setOpenDelete] = useState(false);
  const [arraySubjectIds, setArraySubjectIds] = useState('');
  const [FilterSearch, setFilterSearch] = useState<FilterSearchType>({
    Method: 1,
    Type: 8,
    search: '',
    fromDate: null,
    toDate: null,
    isReplated: false,
    subject: 0,
  });

  const [delsertInfo, setDelsertInfo] = useState({
    sectionId: 0,
    lawId: 0,
    subjectIds: '',
    methodUpsert: FilterSearch.Method,
    mainsubject: '',
    text: '',
  });

  const isReplatedChecked = async (e) => {
setFilterSearch((prev)=>({...prev,isReplated:e.target.checked}))
  };
  const {
    fetchRefreshToken,
    isTokenExpired,
    tokenLogin,
    CodeGozari,
    setCodeGozari,
    fetchCodeGozari,
  }:any = useContext(DataContext);
  
  const subjects = async () => {
    await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/Data/Subjects?metheod=${FilterSearch.Method}`,
    )
      .then((res) => res.json())
      .then((data) => {
        return setSubjectCode(data);
      });
  };
  const GetsubjectsList = async () => {
    await fetch(`${process.env.REACT_APP_BASE_URL}/api/Data/Subjects?metheod=0`)
      .then((res) => res.json())
      .then((data) => {
        return setSubjectList(data);
      });
  };
  console.log(subjectCode);
  const fetchSearch = async () => {
   setisLoading(true)
    await fetch(
      `${
        process.env.REACT_APP_BASE_URL
      }/api/Admin/ListSubject?size=${pagesize}${
        FilterSearch.search !== '' ? '&search=' + FilterSearch.search : ''
      }&page=${page == null ? '1' : page}${
        FilterSearch.fromDate !== null ? '&fromDate=' + FilterSearch.fromDate : ''
      }${
        FilterSearch.toDate !== null ? '&toDate=' + FilterSearch.toDate : ''
      }&lawtype=${FilterSearch.Type}&method=${FilterSearch.Method}&repealed=${FilterSearch.isReplated}${
        FilterSearch.subject !== 0 ? '&subject=' + FilterSearch.subject : ''
      }`,
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setSearchResult(data.data), setpageSearch(data.count);
      })
      .finally(() => setisLoading(false));

    // if (SearchPage === null) {

    // } else {
    //   fetch(
    //     `${
    //       process.env.REACT_APP_BASE_URL
    //     }/api/Admin/ListSubject?size=${pagesize}${
    //       Search !== '' ? '&search=' + Search : ''
    //     }&page=${page}${fromDate !== null ? '&fromDate=' + fromDate : ''}${
    //       ToDate !== null ? '&toDate=' + ToDate : ''
    //     }${Type !== 8 ? '&lawtype=' + Type : 8}${
    //       isReplated ? `&repealed=${isReplated}&method=${Method}${subject!==null ? '&subject='+subject:""}` : ''
    //     }`,
    //   )
    //     .then((res) => res.json())
    //     .then((data) => {
    //       setSearchResult(data.data), setpageSearch(data.count);
   
  };

  const fetchEdit = () => {
    if (!isTokenExpired(tokenLogin.data?.accessToken)) {
      try {
        fetch(
          `${process.env.REACT_APP_BASE_URL}/api/Admin/DelsertSubject?sectionId=${delsertInfo.sectionId}&lawId=${delsertInfo.lawId}&subjectIds=${arraySubjectIds}&method=${delsertInfo.methodUpsert}&mainsubject=${delsertInfo.mainsubject}`,
          {
            method: 'POST',
            headers: {
              'Content-type': 'application/json',
              Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
            },
          },
        )
          .then((res) => {
            if (res.status === 200) {
              setOpen(false);
              fetchSearch();
            }

          })
          .catch((error) => {
            console.log('error', error);
          });
      } catch (error) {
        console.log('error', error);
      }
    } else {
      fetchRefreshToken();
    }
  };
  const delsert = async () => {
    setOpen(false);
    setDelsertInfo((prev) => ({
      ...prev,
      subjectIds: arraySubjectIds,
    }));

    fetchEdit();
  };
  // useEffect(()=>{

  //   fetch(
  //     `${process.env.REACT_APP_BASE_URL}/api/Admin/ListSubject?size=${pagesize}&page=${page}`
  //   ).then((res)=>res.json()).then((data)=>{setcode(data.data);setpageCount(data.count);setisLoading(false)}).catch(error => {
  //     // setError(error);
  //     setisLoading(false);
  //   });

  // },[page])
  useEffect(() => {
    //  setisLoading(true)
    // fetchInfo(page ? page : 1);
 
    fetchSearch();
  }, [FilterSearch, page, pageSearch]);
  useEffect(() => {
    fetchCodeGozari();
    subjects();
    GetsubjectsList();
  }, []);
  let rowNumber = page ? (page - 1) * 10 : 0;
  let rowNumberSearch = SearchPage ? (SearchPage - 1) * 10 : 0;

  const handleSearchBox = (e: any) => {
    setFilterSearch((prev) => ({ ...prev, search: e.target.value }));
    setSearchPage(null);
  };

  const afterpagehandle = async ({ selected }) => {
    setsearchParams({ page: selected + 1 });
    // fetchInfo(selected + 1);
    setPageNum(selected + 1);
    // setisLoading(true)
  };

  const afterpagehandleforSearch = async (data: any) => {
    let currentPage = data.selected + 1;
    setsearchParams({ page: currentPage });
    setSearchPage(data.selected + 1);
  };
  let [arr, setArr] = useState([]);
  let a = [];
  let m = [];
  const EditSubjectCode = (item: object) => {
 
    setDelsertInfo((prev) => ({
      ...prev,
      sectionId: item.Section_ID,
      lawId: item.Law_ID,
      text: item.SectionText,
    }));
    if (item.Subjects.length > 0) {
      item.Subjects.forEach((element) => {
        if (element.IsMain) {
          setDelsertInfo((prev) => ({
            ...prev,

            mainsubject: element.ID,
            methodUpsert: element.Method,
          }));
        } else {
          const z = subjectCode.find(
            (i) => i.id === element.ID && element.IsMain !== true,
          );
          if (z !== undefined) {
            a.push(z);

            m.push(z.id);
          }
        }
        setArr(a);

        const r = m.join(',').toString();
        console.log('r', r);
        console.log('m', m);
        setDelsertInfo((prev) => ({
          ...prev,
          subjectIds: r,
        }));
      });
    }

    setOpen(true);
  };
  console.log(delsertInfo);

  const deleteSubjectIDs = (
    subjectID: string,
    sectionID: number,
    lawId: number,
  ) => {};

  let q = [];

  const handleChangeSize = (e) => {
    console.log('size', e.target.value);
    if (pageNum !== 1) {
      setsearchParams({});
      setPageSize(parseInt(e.target.value));
    } else {
      setPageSize(parseInt(e.target.value));
    }
    // fetchListRelation(page=1)
    // if (e.target.value === "null") {
    //   setPageSize(10)
    // }
    // else {
    //   setPageSize(parseInt(e.target.value))
    // }
  };
  let z = '';
  const handleChangeSelect = (value) => {
    setValue(value);

    const a = delsertInfo.subjectIds.toString();

    value.forEach((item) => {
      const g = q.find((i) => i == item.id.toString());
      console.log(g);
      if (g !== undefined) {
        const m = q.find((i) => i !== item.id.toString());
        q.push(m);
      } else {
        q.push(item.id.toString());
      }
      if (!q.includes(`${a}`)) {
        q.push(a);
      }
    });
    console.log(q);

    z = q.join().toString();
    console.log(z);
    setArraySubjectIds(z);
  };
  const r = [];

  const handleFromDate = (date: Date) => {
    setFilterSearch((prev) => ({
      ...prev,
      fromDate: jalaliFormat(new Date(date), 'yyyy/MM/dd')
    }));
  };
  const handleToDate = (date: Date) => {
    setFilterSearch((prev) => ({
      ...prev,
      toDate: jalaliFormat(new Date(date), 'yyyy/MM/dd')
    }));
    // setToDate(jalaliFormat(new Date(date), 'yyyy/MM/dd'));
  };
  const changeType = (e) => {
    
    if (e.target.value === 'null') {
      setFilterSearch((prev) => ({
        ...prev,
        Type: null,
      }));
      // setType('null');
    } else {
      setFilterSearch((prev) => ({
        ...prev,
        Type: e.target.value,
      }));
    }
  };
  const ConfirmSubjectIsTrue = async (id) => {
    try {
      await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/Admin/ConfirmSubject?id=${id}&isConfirm=true`,
        { method: 'POST' },
      ).then((res) => console.log(res.json()));
    } catch (error) {}
  };
  const ConfirmSubjectIsFalse = async (id) => {
    try {
      await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/Admin/ConfirmSubject?id=${id}&isConfirm=false`,
        { method: 'POST' },
      ).then((res) => console.log(res.json()));
    } catch (error) {}
  };
  console.log(SearchResult);
  // console.log("@@@@",isLoading)
  // console.log(isLoading)
  if (isLoading) return <h1>loading......</h1>;
  return (
    <>
      <Breadcrumb pageName="کد های موضوعی" />
      <div className="w-full max-w-full font-IranSans p-10 rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <div className="w-full grid grid-cols-8  gap-4 items-center justify-between">
          <div className="w-full flex items-center h-full">
            <input
              onChange={handleSearchBox}
              value={FilterSearch.search}
              className="border w-[100%]  font-IranSans relative border-[#E5E1DA] outline-none p-2 rounded-lg ml-3 text-[16px]"
              placeholder="جستجوی قانون"
            />
          </div>
          <div className="flex items-center gap-1 w-full h-full">
            <select
              onChange={(e) =>
                setFilterSearch((prev) => ({
                  ...prev,
                  Method: Number(e.target.value),
                }))
              }
              className="border border-gray-400 w-[100%] py-1  rounded-md"
            >
              {/* <option value="" >روش کدگذاری...</option> */}
              {CodeGozari?.map((item: any) =>
                Number(item.value) === FilterSearch.Method ? (
                  <option selected key={item.value} value={item.value}>
                    {item.item}
                  </option>
                ) : (
                  <option key={item.value} value={item.value}>
                    {item.item}
                  </option>
                ),
              )}
            </select>
          </div>
          <div className="flex items-center gap-1 w-full h-full">
            <select
              onChange={(e) =>
                setFilterSearch((prev) => ({
                  ...prev,
                  subject: Number(e.target.value),
                }))
              }
              className="border border-gray-400 w-[100%] py-1  rounded-md"
            >
              <option value="0"></option>
              {SubjectList?.map((item: any) =>
                Number(item.id) === FilterSearch.subject ? (
                  <option selected key={item.id} value={item.id}>
                    {item.title}
                  </option>
                ) : (
                  <option key={item.id} value={item.id}>
                    {item.title}
                  </option>
                ),
              )}
            </select>
          </div>
          <div className="w-full  md:mt-0 mt-3 flex items-center ">
            <div className="w-full flex items-center  ">
              <label className="ml-3 mr-3">از </label>
              <DatePicker
                className="custom-calendar"
                inputClass="custom-input"
                calendarPosition="bottom-center"
                value={FilterSearch.fromDate}
                locale={persian_fa}
                calendar={persian}
                onChange={handleFromDate}
              />
            </div>
          </div>
          <div className="w-full  md:mt-0 mt-3 flex items-center ">
            <div className="w-full flex items-center ">
              <label className="ml-3 mr-3">تا </label>
              <DatePicker
                className="custom-calendar"
                inputClass="custom-input"
                calendarPosition="bottom-center"
                value={FilterSearch.toDate}
                locale={persian_fa}
                calendar={persian}
                onChange={handleToDate}
              />
            </div>
          </div>
          <div className="w-full mr-3 md:mt-0 mt-3 flex items-center ">
            <LawType changeTypeFun={changeType} />
            {/* <select onChange={changeType} className="border w-[90%] relative border-[#E5E1DA] outline-none p-2 rounded-lg text-[14px]">
              <option value="null">نوع</option>
              <option value="1"></option>
              <option value="2"></option>
            </select> */}
          </div>
          <div className="flex w-full items-center mt-3 mb-4 ml-3">
          <input
              defaultChecked={FilterSearch.isReplated}
              onChange={isReplatedChecked}
              id="default-checkbox"
              type="checkbox"
              value=""
              className="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
            />
            
            <label
              for="default-checkbox"
              className="ms-2 text-sm font-[14px] text-gray-900 dark:text-gray-300 ml-3"
            >
              نمایش همه منسوخه ها
            </label>
          </div>
          <div className="w-full flex items-center">
            <button className="buttonsearch" onClick={() => fetchSearch()}>
              <IoSearchSharp size={35} className="svgIcon " />
            </button>
          </div>
          {/* <div className="w-full flex items-center">
              <div className="">
               
              </div>
              <button>
                <span className="box font-IranSans text-[14px]">
                  کدگذاری هوشمند
                </span>
              </button>
            </div> */}
        </div>
        {/* table */}
        <div className="w-full mt-3">
          <table className="w-full">
            <thead>
              <tr className="font-IranSans w-full bg-[#B1B2FF] text-[#030637]">
                <th className="w-10 border-b p-3 text-[14px] text-center">
                  ردیف
                </th>
                <th className="w-[30rem] border-b p-3 text-[14px] text-center">
                  عنوان قانون
                </th>
                <th className="w-10 border-b p-3 text-[14px] text-center">
                  کد های موضوعی
                </th>
              </tr>
            </thead>
            <tbody>
              {!isLoading && SearchResult.length!==0?
              SearchResult.map((item: any) => {
                let x =
                  item.SectionPath +
                  ' ' +
                  item.LawTitle +
                  ' ' +
                  'مصوب' +
                  item.ApproveDate;
                return (
                  <>
                    <tr>
                      <td className="w-10 border-b p-4 text-[15px] font-IranSans text-center ">
                        {' '}
                        {(rowNumberSearch = rowNumberSearch + 1)}
                      </td>
                      <td className="w-[30rem] border-b p-4 text-[15px] font-IranSans text-center  ">
                        <Link
                          target="_blank"
                          to={`https://ilaws.net/ViewText/${item.Law_ID}`}
                        >
                          {item.SectionType_ID === 5 ? (
                            <div
                              title={x}
                              className="font-bold text-black dark:text-white"
                            >
                              {item.SectionText}
                            </div>
                          ) : (
                            <div
                              title={x}
                              className=" text-black dark:text-white"
                            >
                              {item.SectionText}
                            </div>
                          )}
                        </Link>
                      </td>
                      <td className="w-10  border-b  p-4 font-IranSans text-center">
                        {item.Subjects === null ? (
                          <></>
                        ) : (
                          <>
                            <div className="bg-[#38bdf8] text-[15px] font-IranSans w-[100%] p-1 text-[#ffffff] shadow-md rounded-lg cursor-pointer hover:text-[#38bdf8] border hover:border-[#38bdf8] hover:bg-[#ffffff]">
                              {item.Subjects.map((i: any, index) => {
                                return (
                                  <div
                                    onClick={() => {
                                      setDelsertInfo({
                                        sectionId: 0,
                                        lawId: 0,
                                        subjectIds: '',
                                        methodUpsert: Method,
                                        mainsubject: '',
                                        text: '',
                                      });
                                      EditSubjectCode(item);
                                    }}
                                  >
                                    {i.Title}
                                  </div>
                                );
                              })}
                            </div>
                          </>
                        )}
                      </td>
                    </tr>
                  </>
                );
              }):<>
               <tr>
                نتیجه یافت نشد 
               </tr>
              </>}
              {/* {SearchResult.length == 0 ? (
                <>
                  {code.map((item: any) => {
                    return (
                      <>
                        <tr>
                          <td className="w-10 border-b p-4 text-[15px] font-IranSans text-center ">
                            {' '}
                            {(rowNumber = rowNumber + 1)}
                          </td>
                          <td className="w-[30rem] border-b p-4 text-[15px] font-IranSans text-center  ">
                            <Link
                              target="_blank"
                              to={`https://ilaw.mrc.ir/ViewText/${item.ID}`}
                            >
                              <div className="font-medium text-black dark:text-white">
                                {item.LawTitle}
                              </div>
                            </Link>
                          </td>
                          <td className="w-10  border-b  p-4 font-IranSans text-center">
                            {item.Subjects === null ? (
                              <></>
                            ) : (
                              <div
                                onClick={() =>
                                  EditSubjectCode(
                                    item.SubjectIDs,
                                    item.Section_ID,
                                    item.Law_ID,
                                  )
                                }
                                className="bg-[#38bdf8] text-[15px] font-IranSans w-[100%] p-1 text-[#ffffff] shadow-md rounded-lg cursor-pointer hover:text-[#38bdf8] border hover:border-[#38bdf8] hover:bg-[#ffffff]"
                              >
                                {item.Title}
                              </div>
                            )}
                          </td>
                        </tr>
                      </>
                    );
                  })}
                </>
              ) : (
                <>
                 
                </>
              )} */}
            </tbody>
          </table>
        </div>
        <div className="w-full">
          {SearchResult.length == 0 ? (
            <>
              <div className="flex items-center justify-between">
                <div className="flex items-center w-full">
                  <div className="flex items-center w-full rtl ">
                    <label className="text-[16px]">تعداد نمایش در صفحه </label>
                    <select
                      className="border-b p-1 mr-3 rounded-lg border-gray-400 outline-none"
                      style={{ fontFamily: 'IranSans' }}
                      onChange={handleChangeSize}
                      value={pagesize}
                    >
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="300">300</option>
                      <option value="500">500</option>
                      <option value="1000">1000</option>
                    </select>
                  </div>
                </div>
                <div className="w-full ">
                  <ReactPaginate
                    breakLabel={<span className="mr-4 sm:mr-0">...</span>}
                    nextLabel={
                      <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md mr-4 sm:mr-2 sm:p-2">
                        <BsChevronLeft />
                      </span>
                    }
                    onPageChange={afterpagehandle}
                    pageRangeDisplayed={5}
                    pageCount={
                      pageCount !== 0 && Math.ceil(pageCount / pagesize)
                    }
                    previousLabel={
                      <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md">
                        <BsChevronRight />
                      </span>
                    }
                    initialPage={savePage - 1}
                    containerClassName="flex items-center justify-center mt-4 mb-4 flex-wrap"
                    pageClassName="block border- border-solid border-[#D3D3D3] hover:bg-gray-200 w-10 h-10  flex items-center justify-center rounded-md mr-4"
                    activeClassName={
                      savePage ? 'bg-[#06b6d4] text-white hover:text-black' : ''
                    }
                    // current
                  />
                </div>

                {/* <ReactPaginate
                  className="PaginateBody"
                  previousLabel={<GrFormNext size={25} />}
                  nextLabel={<GrFormPrevious size={25} />}
                  breakLabel={'...'}
                  pageCount={Math.ceil(pageCount / 10)}
                  marginPagesDisplayed={4}
                  onPageChange={afterpagehandle}
                  pageClassName={'reactPaginate'}
                  previousClassName={'previous'}
                  nextClassName={'Next'}
                  breakClassName={'break'}
                /> */}
              </div>
            </>
          ) : (
            <>
              <div className="w-full flex items-center justify-between">
                <div className="w-full flex items-center ">
                  <div className="flex items-center w-full rtl ">
                    <label className="text-[16px]">تعداد نمایش در صفحه </label>
                    <select
                      className="border-b p-1 mr-3 rounded-lg border-gray-400 outline-none"
                      style={{ fontFamily: 'IranSans' }}
                      onChange={handleChangeSize}
                      value={pagesize}
                    >
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="300">300</option>
                      <option value="500">500</option>
                      <option value="1000">1000</option>
                    </select>
                  </div>
                </div>
                <div className="w-full">
                  <ReactPaginate
                    breakLabel={<span className="mr-4 sm:mr-0">...</span>}
                    nextLabel={
                      <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md mr-4 sm:mr-2 sm:p-2">
                        <BsChevronLeft />
                      </span>
                    }
                    onPageChange={afterpagehandleforSearch}
                    pageRangeDisplayed={5}
                    pageCount={
                      pageSearch !== 0 && Math.ceil(pageSearch / pagesize)
                    }
                    previousLabel={
                      <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md">
                        <BsChevronRight />
                      </span>
                    }
                    initialPage={savePage - 1}
                    containerClassName="flex items-center justify-center mt-4 mb-4 flex-wrap"
                    pageClassName="block border- border-solid border-[#D3D3D3] hover:bg-gray-200 w-10 h-10  flex items-center justify-center rounded-md mr-4"
                    activeClassName={
                      savePage ? 'bg-[#06b6d4] text-white hover:text-black' : ''
                    }
                    // current
                  />
                </div>

                {/* <ReactPaginate
                    className="PaginateBody"
                    previousLabel={<GrFormNext size={25} />}
                    nextLabel={<GrFormPrevious size={25} />}
                    breakLabel={'...'}
                    pageCount={Math.ceil(pageSearch / 10)}
                    marginPagesDisplayed={4}
                    onPageChange={afterpagehandleforSearch}
                    pageClassName={'reactPaginate'}
                    previousClassName={'previous'}
                    nextClassName={'Next'}
                    breakClassName={'break'}
                  /> */}
              </div>
            </>
          )}
        </div>
        {isOpen && (
          <>
            <div className="ModalBackground">
              <div className="Modal-innerSubject">
                <FaRegWindowClose
                  onClick={() => setOpen(false)}
                  className="mb-2"
                  size={20}
                />
                <div className=" text-[16px] font-bold w-full font-IranSans text-black">
                  کد گذاری
                </div>
                <div className="w-full  border-2 border-[#E5E1DA] rounded-lg p-5">
                  <div className="w-full   grid grid-cols-1 ">
                    <div className="w-full bg-[#EEEEEE]  flex flex-col mb-10 border p-4 border-[#cbd5e1] rounded-md ">
                      <p className="mb-3">{delsertInfo.text}</p>
                      <label className="font-bold">کد موضوعی موجود :</label>
                      <div className=" w-full flex flex-col">
                        {arr.map((i) => {
                          return (
                            <>
                              <div className="flex w-full rounded-md bg-[#ffffff] items-center justify-between px-2 py-1">
                                <div className="w-full text-[14px]">
                                  {i.title}
                                </div>
                                <div className="w-full flex items-center justify-center ">
                                  <div className="ltr w-full flex">
                                    {/* <AiFillLike
                                      onClick={() => ConfirmSubjectIsTrue(i.id)}
                                      className="text-[20px]  text-gray-400 hover:text-[#0D7C66] cursor-pointer"
                                    /> */}
                                  </div>
                                  {/* <AiFillDislike
                                    onClick={() => ConfirmSubjectIsFalse(i.id)}
                                    className="text-[20px]  text-gray-400 cursor-pointer hover:text-[#B8001F]"
                                  /> */}
                                </div>
                              </div>
                              <hr className="w-full text-[#cbd5e1]" />
                            </>
                          );
                        })}
                      </div>
                    </div>
                    <div className="w-full flex flex-col mb-3">
                      <label className="ml-5  text-[16px] font-IranSans ">
                        کد موضوعی اصلی
                      </label>
                      <div className="w-full rtl">
                        <select
                          onChange={(e) =>
                            setDelsertInfo((prev) => ({
                              ...prev,
                              mainsubject: e.target.value,
                            }))
                          }
                          className="w-full border rounded-md py-1 "
                        >
                          <option></option>
                          {subjectCode.map((i) => {
                            return i.id === delsertInfo.mainsubject ? (
                              <option selected value={i.id}>
                                {i.title}
                              </option>
                            ) : (
                              <option value={i.id}>{i.title}</option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                    <div className="w-full  flex-col  flex">
                      <label className="ml-5  text-[16px] font-IranSans ">
                        کد های موضوعی
                      </label>
                      <div className="w-full rtl">
                        <Select
                          style={{
                            fontFamily: 'IranSans',
                            fontSize: '16px',
                            direction: 'rtl',
                            height: '40px',
                            borderRadius: '5px',
                          }}
                          options={subjectCode}
                          labelField="title"
                          valueField="id"
                          name="select"
                          multi
                          values={arr}
                          searchable={true}
                          placeholder="کد (ها) موضوعی"
                          onChange={handleChangeSelect}
                        />
                      </div>
                    </div>
                  </div>
                  <div className=" flex  gap-5 w-full ltr p-5">
                    {/* <button
                      className="w-32 p-2 font-IranSans rounded-full text-[16px]  text-white flex items-center justify-center
             bg-[#867AE9] font-bold hover:border-2 hover:shadow-2xl hover:shadow-black"
                     
                    >
                      تایید <TiTick className="ml-3" />
                    </button> */}
                    <button
                      onClick={delsert}
                      className="w-32 p-1 font-IranSans rounded-full flex items-center justify-center text-[14px] hover:border-2 text-white bg-[#65B741] font-bold 
              hover:shadow-2xl hover:shadow-black "
                    >
                      ثبت
                      <CiEdit size={20} className="ml-2" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {isOpenDelete && (
          <>
            <div className="font-IranSans font-bold text-[16px] w-full p-5 text-black">
              حذف کد های موضوعی{' '}
            </div>
            <div className="w-full  border-2 border-[#E5E1DA] rounded-lg p-5">
              <div className="w-full grid grid-cols-1 ">
                <label className="ml-5 font-IranSans w-full text-[16px]">
                  کد (های) موضوعی مورد نظر را انتخاب کنید
                </label>
                <div className="w-full  items-center justify-center  flex">
                  <div className="w-full rtl">
                    <Select
                      style={{
                        fontFamily: 'IranSans',
                        fontSize: '16px',
                        direction: 'rtl',
                        height: '50px',
                      }}
                      options={arr}
                      labelField="title"
                      valueField="id"
                      name="select"
                      multi
                      // values={arr}
                      searchable={true}
                      placeholder="کد (ها) موضوعی"
                      onChange={handleChangeSelect}
                    />
                  </div>
                </div>
              </div>
              <div className="flex gap-5 w-full ltr p-5">
                <button
                  className="w-32 font-IranSans p-2 rounded-full text-[16px] text-white flex items-center justify-center
               bg-[#FF6969] font-bold hover:border-2 hover:shadow-2xl hover:shadow-black"
                  onClick={delsert}
                >
                  حذف
                  <MdDelete className="ml-3" />
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default NewSubjectCode;
